module.exports = __webpack_public_path__ + "img/bg.ed77adeb.jpg";